import { c as _c } from "react/compiler-runtime";
import { ActionMenu, ActionMenuItem } from '@systemeio/ui';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { AddHeaderModal } from '../content/header/add-header';
interface Props {
  title: string;
  id: number;
  onDelete: () => Promise<void>;
}
const HeaderItemContent: FC<Props> = t0 => {
  const $ = _c(36);
  const {
    title,
    id,
    onDelete
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [deleteOpened, setDeleteOpened] = useState(false);
  const [editOpened, setEditOpened] = useState(false);
  let t1;
  if ($[0] !== title) {
    t1 = <div className="flex flex-col items-start gap-1"><b className="text-text-primary text-[24px]">{title}</b></div>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setEditOpened(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("global.edit");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <ActionMenuItem key="action-edit" onClick={t2} label={t3} />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setDeleteOpened(true);
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("global.delete");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <ActionMenuItem key="action-delete" onClick={t5} label={t6} />;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <ActionMenu menuItems={[t4, t7]} />;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t("dashboard.store.item.delete_confirmation");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("dashboard.store.item.delete_success");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setDeleteOpened(false);
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== deleteOpened || $[21] !== onDelete || $[22] !== t10 || $[23] !== t9) {
    t12 = <ConfirmationModal confirmationText={t9} toastCaption={t10} opened={deleteOpened} onClose={t11} onConfirm={onDelete} />;
    $[20] = deleteOpened;
    $[21] = onDelete;
    $[22] = t10;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== editOpened || $[26] !== id || $[27] !== title) {
    t13 = <AddHeaderModal id={id} initialText={title} opened={editOpened} setOpened={setEditOpened} />;
    $[25] = editOpened;
    $[26] = id;
    $[27] = title;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t8) {
    t14 = <div className="ml-auto">{t8}{t12}{t13}</div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t8;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t1 || $[34] !== t14) {
    t15 = <div className="flex w-full cursor-pointer items-center gap-5 border-transparent p-5">{t1}{t14}</div>;
    $[33] = t1;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};
export default HeaderItemContent;